import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const TwoColumnAdjustableContainer = (props) => {
  const {
      params,
      rendering
  } = props;
    var column1CSS = params["Column 1 Width"]
    var column2CSS = params["Column 2 Width"]

    return (
        <div class="container clearfix">
            <div className={column1CSS}>
                <Placeholder name="eti-column-one" rendering={rendering} />
            </div>
            <div className={column2CSS}>
                <Placeholder name="eti-column-two" rendering={rendering} />
            </div>
        </div> 
  );
};

export default TwoColumnAdjustableContainer;
